import React from "react";
import { Lock } from "lucide-react";

interface LockBadgeProps {
  /** Tooltip text, e.g. "Locked on 10 Aug 2026". */
  label?: string | null;
  className?: string;
}

/**
 * Marks a row as locked by the current admin.
 *
 * Only ever rendered on the locker's own rows: a locked resource is hidden
 * from everybody else, so nobody else has a row to badge.
 */
const LockBadge: React.FC<LockBadgeProps> = ({ label, className = "" }) => (
  <span
    title={label || "Locked"}
    aria-label={label || "Locked"}
    className={`inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-200 ${className}`}
  >
    <Lock className="h-3 w-3" aria-hidden="true" />
    Locked
  </span>
);

export default LockBadge;
